const commRouter = [
  {
    path: '/',
    redirect: '/shoppingMalll/index'
  },
  {
    path: '/login/index',
    name: '登录',
    component: function (resolve) {
      require(['@/pages/login/index'],resolve)
    }
  },
  {
    path: '/login/phone-login',
    name: '手机号登录',
    component: function (resolve) {
      require(['@/pages/login/phone-login'],resolve)
    }
  },
  {
    path: '/login/wx-login',
    name: '微信登录',
    component: function (resolve) {
      require(['@/pages/login/wx-login'],resolve)
    }
  },{
    path: `/shoppingMalll/index/:storeId*`,   // /shoppingMalll/index/5314
    name: '商城',
    component: function (resolve) {
      require(['@/pages/shoppingMall/index'],resolve)
    }
  },{
    path: '/shoppingMalll/search',
    name: '搜索',
    component: function (resolve) {
      require(['@/pages/shoppingMall/search'],resolve)
    }
  },{
    path: '/shoppingMalll/goodDetails/:goodsId*',
    name: '商品详情',
    component: function (resolve) {
      require(['@/pages/shoppingMall/good-details'],resolve)
    }
  },{
    path: '/shoppingMalll/order',
    name: '提交订单',
    component: function (resolve) {
      require(['@/pages/shoppingMall/order'],resolve)
    }
  },{
    path: '/shoppingMalll/address-list',
    name: '选择收货地址',
    component: function (resolve) {
      require(['@/pages/shoppingMall/address-list'],resolve)
    }
  },{
    path: '/shoppingMalll/address-add',
    name: '选择收货地址',
    component: function (resolve) {
      require(['@/pages/shoppingMall/address-add'],resolve)
    }
  },{
    path: '/shoppingMalll/address-edit',
    name: '修改收货地址',
    component: function (resolve) {
      require(['@/pages/shoppingMall/address-edit'],resolve)
    }
  },{
    path: '/brand/index',
    // path: '/brand/index/:post_id',
    name: '品牌',
    component: function (resolve) {
      require(['@/pages/brand/index'],resolve)
    }
  },{
    path: '/brand/view/:id/:uid/:type',
    name: '文章',
    component: function (resolve) {
      require(['@/pages/brand/view'],resolve)
    }
  },
  {
    path: '/brand/active/:id/:uid/:type',
    name: '动态',
    component: function (resolve) {
      require(['@/pages/brand/active'],resolve)
    }
  },
  {
    path: '/brand/living',
    name: '直播',
    component: function (resolve) {
      require(['@/pages/brand/living'],resolve)
    }
  },
  {
    path: '/brand/monitor',
    name: '监控列表',
    component: function (resolve) {
      require(['@/pages/brand/monitor'],resolve)
    }
  },
  {
    path: '/brand/monitor-index',
    name: '监控',
    component: function (resolve) {
      require(['@/pages/brand/monitor-index'],resolve)
    }
  },
  {
    path: '/shoppingcart/index/:isOrigin*',
    name: '购物车',
    component: function (resolve) {
      require(['@/pages/shoppingcart/index'],resolve)
    }
  },{
    path: '/shoppingcart/order',
    name: '结算',
    component: function (resolve) {
      require(['@/pages/shoppingcart/order'],resolve)
    }
  },{
    path: '/shoppingcart/order-pay',
    name: '支付',
    component: function (resolve) {
      require(['@/pages/shoppingcart/order-pay'],resolve)
    }
  },{
    path: '/service/index',
    name: '客服',
    component: function (resolve) {
      require(['@/pages/service/index'],resolve)
    }
  },{
    path: '/service/list',
    name: '客服列表',
    component: function (resolve) {
      require(['@/pages/service/list'],resolve)
    }
  },{
    path: '/me/index',
    name: '我的',
    component: function (resolve) {
      require(['@/pages/me/index'],resolve)
    }
  },
  {
    path: '/me/seting',
    name: '设置',
    component: function (resolve) {
      require(['@/pages/me/seting'],resolve)
    }
  },
  {
    path: '/me/active-follow',
    name: '动态关注',
    component: function (resolve) {
      require(['@/pages/me/active-follow'],resolve)
    }
  },
  {
    path: '/me/goods-follow',
    name: '商品关注',
    component: function (resolve) {
      require(['@/pages/me/goods-follow'],resolve)
    }
  },
  {
    path: '/me/store-follow',
    name: '商家关注',
    component: function (resolve) {
      require(['@/pages/me/store-follow'],resolve)
    }
  },
  {
    path: '/me/collection',
    name: '收藏',
    component: function (resolve) {
      require(['@/pages/me/collection'],resolve)
    }
  },
  {
    path: '/me/follow-index',
    name: '关注',
    component: function (resolve) {
      require(['@/pages/me/follow-index'],resolve)
    }
  },
  {
    path: '/me/share-index',
    name: '分享',
    component: function (resolve) {
      require(['@/pages/me/share-index'],resolve)
    }
  },
  {
    path: '/me/download',
    name: '下载',
    component: function (resolve) {
      require(['@/pages/me/download'],resolve)
    }
  },
  {
    path: '/follow/card-index',
    name: '关注名片',
    component: function (resolve) {
      require(['@/pages/follow/card-index'],resolve)
    }
  },
  {
    path: '/order/index',
    name: '我的订单',
    component: function (resolve) {
      require(['@/pages/order/index'],resolve)
    }
  },
  {
    path: '/order/details',
    name: '订单详情',
    component: function (resolve) {
      require(['@/pages/order/details'],resolve)
    }
  },
  {
    path: '/order/multiple-logistics',
    name: '物流详情',
    component: function (resolve) {
      require(['@/pages/order/multiple-logistics'],resolve)
    }
  },
  {
    path: '/order/logistics-details',
    name: '物流详情',
    component: function (resolve) {
      require(['@/pages/order/logistics-details'],resolve)
    }
  },
  {
    path: '/order/apply-service',
    name: '申请售后',
    component: function (resolve) {
      require(['@/pages/order/apply-service'],resolve)
    }
  },
  {
    path: '/order/apply-service-refund',
    name: '申请售后退款',
    component: function (resolve) {
      require(['@/pages/order/apply-service-refund'],resolve)
    }
  },
  {
    path: '/order/apply-refund',
    name: '申请退款',
    component: function (resolve) {
      require(['@/pages/order/apply-refund'],resolve)
    }
  },
  {
    path: '/order/refund-details',
    name: '退款详情',
    component: function (resolve) {
      require(['@/pages/order/refund-details'],resolve)
    }
  },
  {
    path: '/order/logistics-form-data',
    name: '退货物流信息填写',
    component: function (resolve) {
      require(['@/pages/order/logistics-form-data'],resolve)
    }
  },
  {
    path: '/order/evaluate',
    name: '评价',
    component: function (resolve) {
      require(['@/pages/order/evaluate'],resolve)
    }
  },
  {
    path: '/order/evaluate-details',
    name: '评价',
    component: function (resolve) {
      require(['@/pages/order/evaluate-details'],resolve)
    }
  },
  {
    path: '/trace/index',
    name: '溯源',
    component: function (resolve) {
      require(['@/pages/trace/index'],resolve)
    }
  },
  {
    path: '/trace/scan-check',
    name: '防伪校验',
    component: function (resolve) {
      require(['@/pages/trace/scan-check'],resolve)
    }
  },
  { // 文字留言路由
    path: '/message/message-board',
    name: '文字留言板',
    component: function (resolve) {
      require(['@/pages/message/message-board/index'],resolve)
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
  ]
  export default commRouter



// WEBPACK FOOTER //
// ./src/router/comm-router.js